import styled from 'styled-components'
import { Theme, PageMain } from 'styles/index'

export const Container = styled(PageMain)<{ isExpanded: boolean }>`
  padding-left: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
  height: 100vh;

  .clientes-container-left {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .clientes-container-right {
    display: flex;
    flex-direction: column;
    gap: 24px;
    transition: all 1s;
    width: ${({ isExpanded }) =>
      isExpanded ? 'calc(100% - 252px)' : 'calc(100% - 48px)'};
  }

  .status-card-container-cards {
    h4 {
      font-family: 'Inter';
      font-size: 16px;
      font-weight: 500;
      line-height: 19.36px;
      text-align: left;

      margin-bottom: 24px;
    }

    .documents-container {
      display: flex;
      gap: 70px;

      margin-bottom: 32px;
    }
  }

  .remover-filtro {
    margin: 0;
    font-size: 12px;
    font-weight: 700;
    text-align: left;
    color: ${Theme.pallete.QUATERNARY2};
    cursor: pointer;
    text-decoration: underline ${Theme.pallete.QUATERNARY2} 1px;
  }
`
